import Vue from 'vue'
import App from './App'
import router from './router'
import promise from 'babel-polyfill'
import Vant from 'vant'
import 'vant/lib/index.css'
import '@vant/touch-emulator'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import '@/util/font-rem'
import * as filters from '@/util/dateFilter.js'
// import style (<= Swiper 5.x)
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper /* { default options with global component } */)
//

Vue.use(Vant)
Vue.use(promise)
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

new Vue({
    el: '#app',
    router,
    // store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js